import { inject, Injectable } from '@angular/core';
import {
  ApiClientService,
  AuditLogEntry,
  IPaginatedResponse,
  TENANT_API
} from '@pharvio/core/shared';
import { Observable } from 'rxjs';

const MOCK_ENTRIES: AuditLogEntry[] = [
  {
    id: 'al-001',
    userId: 'u-01',
    userName: 'Adaeze Okafor',
    action: 'login',
    resource: 'Auth',
    description: 'User logged in',
    ipAddress: '102.89.45.12',
    timestamp: '2026-05-17T08:02:11Z'
  },
  {
    id: 'al-002',
    userId: 'u-02',
    userName: 'Chukwuemeka Nwosu',
    action: 'create',
    resource: 'Invoice',
    resourceId: 'INV-20260517-001',
    description: 'Created invoice INV-20260517-001 for ₦14,500',
    ipAddress: '102.89.45.13',
    timestamp: '2026-05-17T08:15:30Z'
  },
  {
    id: 'al-003',
    userId: 'u-01',
    userName: 'Adaeze Okafor',
    action: 'dispense',
    resource: 'Prescription',
    resourceId: 'RX-2026-00871',
    description:
      'Dispensed prescription RX-2026-00871 — Amoxicillin 500mg x 30',
    ipAddress: '102.89.45.12',
    timestamp: '2026-05-17T08:28:45Z'
  },
  {
    id: 'al-004',
    userId: 'u-03',
    userName: 'Ngozi Eze',
    action: 'approve',
    resource: 'PurchaseOrder',
    resourceId: 'PO-2026-0112',
    description: 'Approved purchase order PO-2026-0112',
    ipAddress: '197.210.55.2',
    timestamp: '2026-05-17T09:05:00Z'
  },
  {
    id: 'al-005',
    userId: 'u-02',
    userName: 'Chukwuemeka Nwosu',
    action: 'void',
    resource: 'Invoice',
    resourceId: 'INV-20260516-008',
    description: 'Voided invoice INV-20260516-008 — item scanned twice',
    ipAddress: '102.89.45.13',
    timestamp: '2026-05-17T09:22:18Z'
  },
  {
    id: 'al-006',
    userId: 'u-04',
    userName: 'Abiodun Fashola',
    action: 'update',
    resource: 'Customer',
    resourceId: 'CUST-001245',
    description:
      'Updated customer profile for Bola Akin — changed phone number',
    ipAddress: '41.66.200.5',
    timestamp: '2026-05-17T09:45:00Z'
  },
  {
    id: 'al-007',
    userId: 'u-03',
    userName: 'Ngozi Eze',
    action: 'adjust',
    resource: 'Inventory',
    resourceId: 'MED-00456',
    description: 'Adjusted stock for Metformin 500mg: +120 units (stock-take)',
    ipAddress: '197.210.55.2',
    timestamp: '2026-05-17T10:10:33Z'
  },
  {
    id: 'al-008',
    userId: 'u-01',
    userName: 'Adaeze Okafor',
    action: 'reject',
    resource: 'RefundTicket',
    resourceId: 'RT-2026-0034',
    description:
      'Rejected refund ticket RT-2026-0034 — product not in sellable condition',
    ipAddress: '102.89.45.12',
    timestamp: '2026-05-17T10:30:00Z'
  },
  {
    id: 'al-009',
    userId: 'u-05',
    userName: 'Tunde Bello',
    action: 'export',
    resource: 'Report',
    description: 'Exported P&L report for April 2026',
    ipAddress: '105.112.88.21',
    timestamp: '2026-05-17T10:55:00Z'
  },
  {
    id: 'al-010',
    userId: 'u-02',
    userName: 'Chukwuemeka Nwosu',
    action: 'create',
    resource: 'Invoice',
    resourceId: 'INV-20260517-012',
    description: 'Created invoice INV-20260517-012 for ₦8,250',
    ipAddress: '102.89.45.13',
    timestamp: '2026-05-17T11:05:44Z'
  },
  {
    id: 'al-011',
    userId: 'u-04',
    userName: 'Abiodun Fashola',
    action: 'update',
    resource: 'Role',
    resourceId: 'role-pharmacist',
    description:
      'Updated role "Pharmacist" — added prescriptions.dispense_controlled permission',
    ipAddress: '41.66.200.5',
    timestamp: '2026-05-16T14:20:00Z'
  },
  {
    id: 'al-012',
    userId: 'u-03',
    userName: 'Ngozi Eze',
    action: 'approve',
    resource: 'RefundTicket',
    resourceId: 'RT-2026-0033',
    description: 'Approved refund ticket RT-2026-0033 — ₦3,200',
    ipAddress: '197.210.55.2',
    timestamp: '2026-05-16T11:45:00Z'
  },
  {
    id: 'al-013',
    userId: 'u-01',
    userName: 'Adaeze Okafor',
    action: 'create',
    resource: 'Prescription',
    resourceId: 'RX-2026-00872',
    description: 'Created prescription RX-2026-00872 for patient Emeka Obi',
    ipAddress: '102.89.45.12',
    timestamp: '2026-05-16T10:30:00Z'
  },
  {
    id: 'al-014',
    userId: 'u-05',
    userName: 'Tunde Bello',
    action: 'delete',
    resource: 'Customer',
    resourceId: 'CUST-000987',
    description: 'Deleted customer CUST-000987 — duplicate account',
    ipAddress: '105.112.88.21',
    timestamp: '2026-05-16T09:15:00Z'
  },
  {
    id: 'al-015',
    userId: 'u-04',
    userName: 'Abiodun Fashola',
    action: 'logout',
    resource: 'Auth',
    description: 'User logged out',
    ipAddress: '41.66.200.5',
    timestamp: '2026-05-15T17:58:00Z'
  }
] as any;

@Injectable({ providedIn: 'root' })
export class AuditLogService {
  private readonly api = inject(ApiClientService);
  getEntries(
    params?: Record<string, string>
  ): Observable<IPaginatedResponse<AuditLogEntry>> {
    return this.api.get<IPaginatedResponse<AuditLogEntry>>(
      TENANT_API.AUDIT_LOGS.BASE,
      params
    );
  }
}
